export default __webpack_public_path__ + "static/media/recommendations-lcb-preview.4f69b6db.png";